import "../stylesheets/App.css";
import "../stylesheets/Rules.css";
import React, { useEffect } from "react";
import Header from "./subcomponents/Header.js";
import { useNavigate } from "react-router-dom";

function Rules() {
  const navigate = useNavigate();

  useEffect(() => {
    // Si no está logueado, lo mando a login
    if (!localStorage.getItem("user-info")) {
      navigate("/login");
      return;
    }

    // Ocultar buscador (safe)
    const el = document.getElementById("search-container");
    if (el) el.style.display = "none";
  }, [navigate]);

  return (
    <>
      <Header />
      <section className="rules-container">
        <h1 className="rules-title">Mecánica de juego</h1>
        <h2 className="rules-title"> Reglas Quiniela Mundialista 2026</h2>
        <div className="rules-div">
          <p className="rules-text">
            Te damos la bienvenida a la plataforma oficial de pronósticos para el Mundial 2026. A continuación, se detallan los términos, la mecánica de juego y el sistema de puntuación que regirán la competencia.
          </p>
        </div>
        <div className="rules-div">
          <h2 className="rules-subtitle">Fase Grupos</h2>
          <ul className="rules-list">
            <li>Si acierta el resultado y el marcador exacto: Suma 5 puntos.</li>
            <li>Si acierta parcialmente el resultado (el ganador o el empate, pero no el marcador): Suma 3 puntos.</li>
            <li>Si no acierta el resultado: Obtiene 0 puntos.</li>
          </ul>
        </div>

        <div className="rules-div">
          <h2 className="rules-subtitle">
            Rondas de Eliminación Directa (Dieciseisavos, Octavos, Cuartos y Semifinales)
          </h2>
          <ul className="rules-list">
            <li>Si acierta el resultado y el marcador exacto: Suma 10 puntos.</li>
            <li>Si acierta parcialmente el resultado (el ganador o el empate, pero no el marcador): Suma 5 puntos.</li>
            <li>Si no acierta el resultado: Obtiene 0 puntos.</li>
          </ul>
        </div>

        <div className="rules-div">
          <h2 className="rules-subtitle">Gran Final y Tercer Lugar</h2>
          <ul className="rules-list">
            <li>Si acierta el resultado y el marcador exacto: Suma 15 puntos.</li>
            <li>Si acierta parcialmente el resultado (el ganador o el empate, pero no el marcador): Suma 8 puntos.</li>
            <li>Si no acierta el resultado: Obtiene 0 puntos.</li>
          </ul>
          <p className="rules-text">
            No existe otra forma de lograr puntos. Los resultados podrán consultarse al final de cada jornada mundialista.
          </p>
        </div>
        <div className="rules-div">
          <h2 className="rules-subtitle">Regulación de Tiempo Oficial:</h2>
          <p className="rules-text">
            Para el cálculo de los puntos se considerará únicamente el resultado oficial al concluir los 90 minutos reglamentarios más el tiempo de reposición, incluyendo los tiempos extras (dos tiempos de 15 minutos) si llegaran a disputarse. Las tandas de penales quedan totalmente excluidas para efectos de la quiniela.
          </p>
        </div>
        <div className="rules-div">
          <h2 className="rules-subtitle">Tiempos de Bloqueo y Participación</h2>
          <ul className="rules-list">
            <li><strong>Límite de Predicción:</strong> La plataforma cerrará de forma automática el ingreso o modificación de sus pronósticos <strong>15 minutos antes</strong> de la hora oficial de inicio de cada partido. Transcurrido este límite, el sistema bloqueará el partido y no se podrán sumar puntos por dicho encuentro.</li>
            <li><strong>Ingreso Tardío:</strong> Usted puede unirse a la quiniela en cualquier momento del torneo. No completar la totalidad de los partidos de la competencia no invalida su cuenta; simplemente no acumulará puntos por los partidos omitidos.</li>
          </ul>
        </div>
        <div className="rules-div">
          <h2 className="rules-subtitle">Determinación del Ganador y Desempates</h2>
          <p className="rules-text">
            La tabla de posiciones se actualizará al término de cada jornada con base en los datos y resultados oficiales publicados por la FIFA. Al concluir el torneo, se consagrará como Ganador Absoluto el usuario que ocupe la primera posición de la tabla general acumulada.
          </p>
          <p className="rules-text">
            En caso de presentarse una igualdad de puntos entre dos o más usuarios al cierre del torneo, se definira de la siguiente manera: 
          </p>
          <ol className="rules-list">
            <li>Mayor número de marcadores exactos: Clasificará más alto el usuario que haya registrado una mayor cantidad de aciertos exactos a lo largo de todo el torneo.</li>
            <li>Fecha de Registro: Si la igualdad persiste, la posición de ganador se le otorgará al usuario cuyo registro cronológico en la plataforma se haya realizado primero.</li>
          </ol>
        </div>
      </section>
    </>
  );
}

export default Rules;
